import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Header from './components/Header';
import EditLeadDetailsPopup from './components/EditLeadPopup';
import LeadHistoryPopup from './components/LeadHistoryPopup';
import AddResponsePopup from './components/AddResponsePopup';
import axios from 'axios';
import SignUpPopup from './components/SignUpPopup';
import FullPageLoader from './components/FullPageLoader';

const ViewLeadDetails = () => {

    const [clientDetails, setClientDetails] = useState([]);
    const [clientResponses, setClientResponses] = useState([]);
    const [leadDetailsHistory, setLeadDetailsHistory] = useState([]);
    const [clientRequirement, setClientRequirement] = useState([]);
    const [requirementHistory, setRequirementHistory] = useState([]);
    const [userDetails, setUserDetails] = useState([]);

    const [toggleEditLeadPopup, setToggleEditLeadPopup] = useState(0);
    const [toggleResponsePopup, setToggleResponsePopup] = useState(0);
    const [toggleSignUpPopup, setToggleSignUpPopup] = useState(0);

    const [toggleLeadHistoryPopup, setToggleLeadHistoryPopup] = useState(0);

    const [pageLoader, setPageLoader] = useState(0);
    const [designation, setDesignation] = useState();

    const navigate = useNavigate();
    const { leadId, visit } = useParams();


    const url = window.url;
    const qry = new FormData();

    useEffect(() => {
        setPageLoader(1);
        if (localStorage.getItem("user")) {
            const userData = JSON.parse(localStorage.getItem("user"));
            setUserDetails(userData);

            // console.log(userData);

        }
        fetchLeadDetailssApi();
    }, []);


    const fetchLeadDetailssApi = () => {
        setPageLoader(1);
        qry.append("lead_id", leadId);

        axios.post(url + "fetch-lead-details.php", qry).then((response) => {
            if (response.data.status == 1) {
                setClientDetails(response.data.details);
                setClientResponses(response.data.responses);
                setLeadDetailsHistory(response.data.lead_details_history);
                console.log(response.data);
            }
            setPageLoader(0);
            // console.log(response.data);
        }).catch(error => {
            console.log(error.message);

            if (error.message == "Network Error") {
                fetchLeadDetailssApi();
            }
        });

    }


    const closeEditLeadPopup = () => {
        setToggleEditLeadPopup(0);
    }

    const closeAddResponsePopup = () => {
        setToggleResponsePopup(0);
    }

    const closeSignUpPopup = () => {
        setToggleSignUpPopup(0);
    }

    const closeLeadHistoryPopup = () =>{
        setToggleLeadHistoryPopup(0);
    }


    const inventoryFoundApi = () => {
        var confirm = window.confirm("Are you sure ?");
        // alert(confirm);

        if (confirm == 1) {
            setPageLoader(1);
            qry.append("lead_id", leadId);
            qry.append("emp_id", "");

            axios.post(url + "set-found-inventory.php", qry).then((response) => {
                if (response.data.status == 1) {
                    alert("Done");
                    fetchLeadDetailssApi();
                    // console.log(response.data);
                }
                else {
                    alert("something went wrong!")
                }
                setPageLoader(0);
            }).catch(error => {
                console.log(error.message);

                if (error.message == "Network Error") {
                    fetchLeadDetailssApi();
                }
            });
        }
    }
    return (
        <>
            <Header />

            {toggleEditLeadPopup === 1 ?
                <EditLeadDetailsPopup data={clientDetails} reload={fetchLeadDetailssApi} leadId={clientDetails.id} close={closeEditLeadPopup} />
                : <></>
            }

            {toggleLeadHistoryPopup === 1 ?
                <LeadHistoryPopup data={leadDetailsHistory} close={closeLeadHistoryPopup} />
                : <></>
            }

            {toggleResponsePopup === 1 ?
                <AddResponsePopup reload={fetchLeadDetailssApi} leadId={leadId} visit={visit} close={closeAddResponsePopup} />
                : <></>
            }

            {toggleSignUpPopup === 1 ?
                <SignUpPopup reload={fetchLeadDetailssApi} leadId={leadId} visit={visit} close={closeSignUpPopup} />
                : <></>
            }

            {pageLoader == 1 ?
                <FullPageLoader />
                : <></>
            }

            <div className='container-head'>
                <div style={{ "width": "61%" }}>
                    <h2> {clientDetails.name} </h2>
                </div>

                <div>
                    {(userDetails.designation == "A" || userDetails.designation == "D" || userDetails.designation == "E" || userDetails.designation == "F") ? <button onClick={() => { setToggleResponsePopup(1) }} className='crm-btn-primary'> Response <i className='fa fa-reply'></i> </button>
                        : <></>}
                </div>

            </div>
            <div className='crm-container'>

                <div className='view-lead-page'>
                    <div className='cards-flex'>
                        <div className='lead-details-card'>

                            <div className='table-item-right'>
                                <div>
                                    <h2>{clientDetails.name} </h2>
                                </div>
                                <div>
                                    <a href={"tel:" + clientDetails.phone}><i className='fa fa-phone'></i> {clientDetails.phone} </a>
                                    <a href={"https://api.whatsapp.com/send?phone=91" + clientDetails.phone + "&text=hello"} target='blank'><i className='fa fa-whatsapp'></i> WA </a>
                                </div>
                                <div>
                                    <a href={"mailto:" + clientDetails.email} style={{ color: "blue" }}> <i className='fa fa-envelope'></i> {clientDetails.email} </a>
                                </div>
                                <div>
                                    <p> Lead Date {clientDetails.lead_date} </p>
                                </div>
                                <div className='lead-details-card-right'>

                                    {/* {
                                        clientDetails.clientResponses.sign_up_date != "" ?
                                        
                                            {// <h3> Visit On {data.sign_up_date}</h3>}
                                            :
                                            <h3> Follow Up</h3>
                                    }    */}

                                    <h3 className={clientDetails.process_status == 4 ? 'crm-color-green' : 'crm-color-primary'}>{clientDetails.process_status == 1 ? "" : clientDetails.process_status == 2 ? "" : clientDetails.process_status == 3 ? "Follow Up" : clientDetails.process_status == 4 ? "Ready to Sign Up " : clientDetails.process_status == 5 ? "Signed On: " + clientDetails.sign_up_date : clientDetails.process_status == 6 ? "Closed" : clientDetails.process_status == 7 ? "Payment Done" : clientDetails.process_status == 8 ? "Not Interested" : ""} ({clientDetails.status_tag})</h3>
                                </div>

                                <div>
                                    {(userDetails.designation == "A" || userDetails.designation == "D" || userDetails.designation == "E" || userDetails.designation == "F") && clientDetails.process_status == 4 ? <button onClick={() => { setToggleSignUpPopup(1) }} className='crm-btn-primary'><i className='fa fa-check'></i> Sign Up </button>
                                        : <></>}
                                </div>

                                <div className='requirement-message'>
                                    <p>Message: {clientDetails.message} </p>
                                </div>
                            </div>

                            <div className='lead-for'>
                                <span>Lead for: {clientDetails.work}</span>
                            </div>

                            
                        </div>

                        <div className='lead-details-card'>
                            <div style={{ "width": "100%" }}>
                                <div className='lead-details-card-right'>
                                    <h2>Business Name :</h2> <p>{clientDetails.business_name} </p>
                                </div>
                                <div className='lead-details-card-right'>
                                    <h2>Business Category : </h2> <p>{clientDetails.business_category}</p>
                                </div>
                                <div className='lead-details-card-right'>
                                    <h2>Website : </h2><a href={clientDetails.website} target='_blank'>{clientDetails.website}</a>
                                </div>
                                <div className='lead-details-card-right'>
                                    <h2>GMB : </h2> <a href={clientDetails.gmb} target='_blank'>{clientDetails.gmb}</a>
                                </div>
                                <div className='lead-details-card-right'>
                                    <h2>Location : </h2> <a href={clientDetails.gmb} target='_blank'>{clientDetails.location}</a>
                                </div>
                                <div className='lead-details-card-right'>
                                    <h2>Work : </h2> {clientDetails.work}
                                </div>

                                {userDetails.designation == "A" || userDetails.designation == "D" || userDetails.designation == "F" ? <div className='lead-details-card-right'>
                                    <h2> </h2> <p> <i onClick={() => setToggleLeadHistoryPopup(1)} className='fa fa-history edit'></i> <i onClick={() => setToggleEditLeadPopup(1)} className='fa fa-edit edit'></i> </p>
                                </div>
                                    : <></>}
                            </div>
                            {/* <div className='div'>
                                <div className='lead-details-card-right'>
                                    <h2> Location :</h2> <p> {clientRequirement != [] ? clientRequirement.location : "N/A"}</p>
                                </div>

                                <div className='lead-details-card-right'>
                                    <h2> Property Type :</h2> <p> {clientRequirement != [] ? clientRequirement.property_type : "N/A"} </p>
                                </div>

                                <div className='lead-details-card-right'>
                                    <h2> Size :</h2> <p> {clientRequirement != [] ? clientRequirement.size : "N/A"} </p>
                                </div>

                                <div className='lead-details-card-right'>
                                    <h2> Client Category :</h2> <p> {clientRequirement != [] ? clientRequirement.client_category : "N/A"} </p>
                                </div>

                                <div className='lead-details-card-right'>
                                    <h2> Budget ₹ :</h2> <p> {clientRequirement != [] ? clientRequirement.budget : "N/A"} </p>
                                </div>

                                {userDetails.designation == "A" || userDetails.designation == "D" || userDetails.designation == "F" ? <div className='lead-details-card-right'>
                                    <h2> </h2> <i onClick={() => setToggleEditLeadPopup(1)} className='fa fa-edit edit'></i>
                                </div>
                                    : <></>}

                                <div className='requirement-message'>
                                    <p>Message: {clientRequirement.message} </p>
                                </div>

                                <div className='lead-details-card-right'>
                                    <div>
                                        {(userDetails.designation == "A" || userDetails.designation == "D" || userDetails.designation == "E" || userDetails.designation == "F") && clientDetails.inventory_status == 0 ? <button onClick={() => inventoryFoundApi()} className='crm-btn-primary'><i className='fa fa-check'></i> Inv Found </button>
                                            : <></>}
                                    </div>
                                </div>


                            </div> */}
                        </div>
                    </div>

                    <div className='follow-up-section'>

                        <h2 className='h2'> <i className='fa fa-headphones'></i> Follow Up</h2>

                        <div>

                            {clientResponses != [] || clientResponses != "" ?
                                clientResponses.map(data => {
                                    return (
                                        <>
                                            <div className='follow-up-card'>
                                                <div>
                                                    <h2> <i className='fa fa-clock-o'></i> {data.call_date} | {data.call_time} </h2>
                                                    <h2> Next Follow Up : {data.next_follow_date} | {data.next_follow_time} </h2>
                                                </div>

                                                <div className='lead-response'>
                                                    <p> {data.response} </p>

                                                    {
                                                        data.sign_up_date != "" ?
                                                            <h3 className='crm-color-green'> Paid On {data.sign_up_date} <p>{data.emp_name} </p></h3>
                                                            :
                                                            <>  <h3 className={data.tag == "ready" ? 'crm-color-green' : 'crm-color-primary'}> {data.tag == "ready" ? "Ready to Sign Up " : "Follow Up"}  <p style={{ "color": "var(--secondary)" }}>{data.emp_name} ({data.designation}) </p></h3> </>
                                                    }

                                                </div>

                                                <span className={data.tag == "ready" ? 'response-tag crm-bg-green' : 'response-tag'}> {data.tag} </span>
                                            </div>
                                        </>
                                    )
                                })
                                : clientResponses.length == 0 ? <>
                                    <div className='follow-up-card'>Not Yet {clientResponses.length} </div>
                                </>
                                    : <></>

                            }

                            {clientDetails.process_status == 5 ?
                                <>
                                    <h2 className='crm-color-green' style={{ "font-size": "20px", "float": "right", "padding-bottom": "20px" }}> Signed on: {clientDetails.sign_up_date}</h2>
                                    <br />
                                    <p>Sign Up Messaage: {clientDetails.final_response}</p>
                                </>
                                : <></>
                            }


                        </div>
                    </div>

                </div>

            </div>
        </>


    );
}

export default ViewLeadDetails;